import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { message } from "antd";
import ApiCaller from "../../../../../Api/Connection/ApiCaller";
import "./input.css";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

function RenderChangePassModal(props) {
  const [newpassword, setNewpassword] = useState("");
  const [confirmpassword, setConfirmpassword] = useState("");
  const [oldpassword, setOldpassword] = useState("");
  const [allowSeeOldpassword, setAllowSeeOldpassword] = useState("");
  const [allowSeeNewpassword, setAllowSeeNewpassword] = useState(false);
  const [allowSeeConfirmpassword, setAllowSeeConfirmpassword] = useState(false);
  let user = JSON.parse(JSON.stringify(props.curChangePassUser));
  let testStrText = /[a-zA-Z]/g;
  let testStrNum = /[1-9]/g;
  let BEAER = `bearer ${props.globalState.token}`;
  useEffect(() => {
    setOldpassword("");
    setNewpassword("");
    setConfirmpassword("");
  }, [props.changePassModal]);
  var changePassword = () => {
    if (newpassword !== confirmpassword) {
      message.error(`${props.t("Password and confirm password do not match!")}`);
      return false;
    } else if (newpassword == "" || confirmpassword == "") {
      message.error(`${props.t("New password and confirm password cannot be empty")}`);
      return false;
    } else if (newpassword.length < 8) {
      message.error(`${props.t("Password must be at least 8 characters long")}`);
      return false;
    } else if (
      testStrText.test(newpassword) == false ||
      testStrNum.test(newpassword) == false
    ) {
      message.error(
        `${props.t("Password must contain both letters and numbers")}`
      );
      return false;
    } else {
      const data = {
        UserID: user.userID.trim(),
        PasswordOld: oldpassword,
        PasswordNew: newpassword,
      };
      ApiCaller.put(`/web-users/change-password`, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${BEAER}`,
        },
      }).then((response) => {
        if (response.data.isSuccess === true) {
          message.success(props.t("Password changed successfully"));
          props.setChangePassModal(false);
        } else {
          message.error(props.t(response.data.err.msgString));
        }
      });
    }
  };
  return user.userID != undefined ? (
    <Modal
      isOpen={props.changePassModal}
      toggle={() => props.setChangePassModal(false)}
    >
      <ModalHeader>{props.t("CHANGE PASSWORD")}</ModalHeader>
      <ModalBody>
        <Row>
          {props.globalState.userID.trim() != user.userID.trim() ? (
            <></>
          ) : (
            <Col md={12}>
              <FormGroup>
                <InputGroup>
                  <InputGroupAddon
                    className="inputPassword"
                    addonType="prepend"
                    style={{ width: "122px" }}
                  >
                    {props.t("Old Password")}{" "}
                  </InputGroupAddon>
                  <Input
                    type={allowSeeOldpassword == true ? "text" : "password"}
                    name="oldpassword"
                    id="oldpassword"
                    required
                    maxLength={10}
                    placeholder={props.t("Enter old password")}
                    value={oldpassword}
                    onChange={(e) => {
                      setOldpassword(e.target.value);
                    }}
                  />
                  {/* <InputGroupAddon
                    addonType="append"
                    style={{ cursor: "pointer", width: 46 }}
                    onClick={() => {
                      setAllowSeeOldpassword(!allowSeeOldpassword);
                    }}
                  >
                    <InputGroupText style={{ width: 46 }}>
                      <FontAwesomeIcon
                        icon={allowSeeOldpassword ? faEye : faEyeSlash}
                      />
                    </InputGroupText>
                  </InputGroupAddon> */}
                </InputGroup>
              </FormGroup>
            </Col>
          )}

          <Col md={12}>
            <FormGroup>
              <InputGroup>
                <InputGroupAddon
                  className="inputPassword"
                  addonType="prepend"
                  style={{ width: "122px" }}
                >
                  {props.t("New Password")}{" "}
                </InputGroupAddon>
                <Input
                  type={allowSeeNewpassword == true ? "text" : "password"}
                  name="newpassword"
                  id="newpassword"
                  required
                  maxLength={10}
                  placeholder={props.t("Enter new password")}
                  value={newpassword}
                  onChange={(e) => {
                    setNewpassword(e.target.value);
                  }}
                />
                {/* <InputGroupAddon
                  addonType="append"
                  style={{ cursor: "pointer", width: 46 }}
                  onClick={() => {
                    setAllowSeeNewpassword(!allowSeeNewpassword);
                  }}
                >
                  <InputGroupText style={{ width: 46 }}>
                    <FontAwesomeIcon
                      icon={allowSeeNewpassword ? faEye : faEyeSlash}
                    />
                  </InputGroupText>
                </InputGroupAddon> */}
              </InputGroup>
            </FormGroup>
          </Col>
          <Col md={12}>
            <FormGroup>
              <InputGroup>
                <InputGroupAddon
                  className="inputPassword"
                  addonType="prepend"
                  style={{ width: "122px", textAlign: "center" }}
                >
                  {props.t("Confirm password")}{" "}
                </InputGroupAddon>
                <Input
                  type={allowSeeConfirmpassword == true ? "text" : "password"}
                  name="confirmpassword"
                  id="confirmpassword"
                  required
                  maxLength={15}
                  placeholder={props.t("Enter confirm password")}
                  value={confirmpassword}
                  onChange={(e) => {
                    setConfirmpassword(e.target.value);
                  }}
                />
                {/* <InputGroupAddon
                  addonType="append"
                  style={{ cursor: "pointer", width: 46 }}
                  onClick={() => {
                    setAllowSeeConfirmpassword(!allowSeeConfirmpassword);
                  }}
                >
                  <InputGroupText style={{ width: 46 }}>
                    <FontAwesomeIcon
                      icon={allowSeeConfirmpassword ? faEye : faEyeSlash}
                    />
                  </InputGroupText>
                </InputGroupAddon> */}
              </InputGroup>
            </FormGroup>
          </Col>
        </Row>
        {/* <div style={{ color: "blue" }}>
          {props.t(
            "The password must be 8 characters long and include both letters and numbers."
          )}{" "}
        </div> */}
      </ModalBody>
      <ModalFooter>
        <Row
          className="mt-2"
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 20,
            marginRight: "2px",
          }}
        >
          <Button
            color="danger"
            onClick={() => props.setChangePassModal(false)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="18"
              width="18"
              viewBox="0 0 512 512"
              className="mr-1"
              style={{ marginBottom: 3 }}
            >
              <path
                fill="white"
                d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
              />
            </svg>
            {props.t("Close")}
          </Button>
          <Button
            color="success"
            className="mx-2"
            onClick={() => changePassword()}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="16"
              width="16"
              viewBox="0 0 512 512"
              className="mr-1"
              style={{ marginBottom: 3 }}
            >
              <path
                fill="white"
                d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"
              />
            </svg>
            {props.t("Save")}
          </Button>
        </Row>
      </ModalFooter>
    </Modal>
  ) : (
    <></>
  );
}

export default withTranslation(["dashboard"])(RenderChangePassModal);
